import { AppSpecificCopy } from '@/themes';

export const copy: AppSpecificCopy = {
  footer: {
    customFooterLinks: [
      {
        links: [
          {
            href: 'https://www.johnlewisfinance.com/credit-cards/partnership-card.html',
            text: 'Partnerships Credit Card',
          },
          {
            href: 'https://www.johnlewisfinance.com/insurance/home-insurance.html',
            text: 'Home Insurance',
          },
          {
            href: 'https://www.johnlewisfinance.com/insurance/car-insurance.html',
            text: 'Car Insurance',
          },
          {
            href: 'https://www.johnlewisfinance.com/insurance/pet-insurance.html',
            text: 'Pet Insurance',
          },
          {
            href: 'https://www.johnlewisfinance.com/currency.html',
            text: 'Travel Money',
          },
          {
            href: 'https://www.johnlewisfinance.com/money-transfer.html',
            text: 'International Payments',
          },
          {
            href: 'https://www.johnlewisfinance.com/personal-loans.html',
            text: 'Loans',
          },
          {
            href: 'https://www.johnlewisfinance.com/investments.html',
            text: 'Investments',
          },
        ],
        heading: 'Our products',
      },
      {
        links: [
          {
            href: 'https://www.johnlewisfinance.com/accessibility.html',
            text: 'Accessibility',
          },
          {
            href: 'https://www.johnlewisfinance.com/help.html',
            text: 'Contact us',
          },
          {
            href: 'https://www.johnlewisfinance.com/help.html',
            text: 'FAQs',
          },
        ],
        heading: 'Help',
      },
      {
        links: [
          {
            href: 'https://www.johnlewisfinance.com/about-us.html',
            text: 'About John Lewis Money',
          },
          {
            href: 'https://www.johnlewisfinance.com/authors.html',
            text: 'Meet our money experts',
          },
          {
            href: 'https://www.johnlewisfinance.com',
            text: 'John Lewis & Partners',
          },
          {
            href: 'https://www.johnlewis.com/our-services/paymentplans',
            text: 'Payment plans',
          },
          {
            href: 'https://www.waitrose.com/',
            text: 'Waitrose & Partners',
          },
          {
            href: 'https://www.jlpjobs.com/',
            text: 'Jobs',
          },
        ],
        heading: 'The Partnership',
      },
      {
        links: [
          {
            href: 'https://www.johnlewisfinance.com/legal.html',
            text: 'Terms and conditions',
          },
          {
            href: 'https://www.johnlewispartnership.co.uk/csr/reporting/modern-slavery-statement.html',
            text: 'Modern slavery statement',
          },
          {
            href: 'https://www.johnlewisfinance.com/privacy.html',
            text: 'Privacy notice',
          },
          {
            href: 'https://www.johnlewisfinance.com/cookies.html',
            text: 'Cookies',
          },
          {
            href: 'https://www.johnlewis.com/content/sustainability',
            text: 'Sustainability',
          },
          {
            href: 'https://www.johnlewisfinance.com/sitemap.html',
            text: 'Sitemap',
          },
        ],
        heading: 'Legal',
      },
    ],
    mainCustomLegalCopy: [
      'John Lewis Finance Limited introduces personal loans provided by Zopa Bank.',
      'John Lewis Finance Limited is a credit broker (firm reference number: 1018169). Registered office: 1 Drummond Gate, Pimlico, London SW1V 2QQ. Registered in England and Wales (company number: 15785347). John Lewis Finance Limited is a credit broker, not a lender.',
      'Credit is provided by Zopa Bank. Registered office: Zopa Bank, Level 12, 20 Water Street, Canary Wharf, London E14 5GX. Zopa Bank Limited is authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and the Prudential Regulation Authority (firm reference number: 800542).',
      `© John Lewis plc 2001 - ${new Date().getFullYear()}`,
    ],
  },
  pages: {
    index: {
      consents:
        ' Zopa may use your details to suggest the best products for you and send you occasional news and offers. You can ',
      subtitle: `For us to check if you're eligible for a loan with us, we need you to confirm a few details.`,
      marketingAdditional: ' of Zopa marketing',
      title: 'Check your eligibility',
    },
  },
  annualIncome: {
    subtitle:
      'This is just your personal income from your work or pension, not a combined household income. If your income is due to change within the next 12 months, please provide the lower figure.',
    title: 'Annual income before tax',
  },
  dependants: {
    subtitle: 'Someone who relies on you financially. This includes children, partners or friends.',
    title: 'Dependants',
  },
};
